import useSwitchState from '@anm/hooks/useSwitchState';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { streamSelectors } from '../../../../store/modules/stream';

const useCanShowStreamModal = () => {
  const [isNewStreamModalOpened, openNewStreamModal, closeNewStreamModal] = useSwitchState();

  const roomId = useSelector(streamSelectors.selectCreatedStreamRoomID);

  useEffect(() => {
    if (!roomId) return;

    isNewStreamModalOpened && closeNewStreamModal();
  }, [roomId]);

  return [isNewStreamModalOpened, openNewStreamModal, closeNewStreamModal] as const;
};

export default useCanShowStreamModal;
